import {
  AnalyticsFragment,
  MyVaroSectionTileFragment,
} from 'services/graphql/fragments/VxlFragments';
import { gql } from 'urql';

const MyVaroMenuTile = gql`
  query myVaroMenuTile($id: ID!) {
    myVaroMenuTile(
      input: {
        id: $id
        tileType: [MY_VARO_MENU_TILE, MY_VARO_SECTION_TILE, MY_VARO_VXL_TILE]
      }
    ) {
      __typename
      id
      status
      tileType
      displayAnalytics {
        ...analytics
      }
      tiles {
        __typename
        id
        status
        tileType
        ...MyVaroSectionTileFragment
      }
    }
  }
  ${AnalyticsFragment}
  ${MyVaroSectionTileFragment}
`;

export default MyVaroMenuTile;
